import FilteredResultsHeader from './FilteredResultsHeader';
export default FilteredResultsHeader;